module.exports = __webpack_public_path__ + "img/off2.4a8d4391.svg";